module.exports = __webpack_public_path__ + "static/img/test_tab1.a87ccf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/test/test_tab1.png
// module id = e1Np
// module chunks = 1